// permission-route-map.ts

import { PERMISSIONS } from './permissions.constants';

export const PERMISSION_ROUTE_MAP = [
  {
    permission: PERMISSIONS.BOOKING.CREATE,
    route: '/school/bookings/booking-request'
  },
  {
    permission: PERMISSIONS.PRECONFIRM_BOOKING.CREATE,
    route: '/school/bookings/preconfirm-booking'
  },
  {
    permission: PERMISSIONS.BOOKING_CONFIRMATION.CREATE,
    route: '/school/bookings/booking-confirmation'
  },
  {
    permission: PERMISSIONS.CIRCUIT_BOOKING.CREATE,
    route: '/school/bookings/circuit-booking'
  },
  {
    permission: PERMISSIONS.MY_LIST.VIEW,
    route: '/school/manage/my-list'
  },
  {
    permission: PERMISSIONS.SMART_GROUPS.VIEW,
    route: '/school/manage/smart-groups'
  },
  {
    permission: PERMISSIONS.FIND_NEW_TEACHER.VIEW,
    route: '/school/discover/find-new'
  },
  {
    permission: PERMISSIONS.CALENDAR.VIEW,
    route: '/school/calendar'
  },
  {
    permission: PERMISSIONS.BOOKING_HISTORY.VIEW,
    route: 'school/bookings/history'
  },
  {
    permission: PERMISSIONS.PAYROLL_REPORT.VIEW,
    route: '/school/reports/payroll'
  },
  {
    permission: PERMISSIONS.INSIGHTS.VIEW,
    route: '/school/reports/insights'
  },
];